import axios from "axios";
import { AxiosInstance } from "axios";
import { TranslationObject } from "../types";

// Types for translation payload
interface TranslationItem {
  key: string;
  text: string;
}

// Function to use AI to translate text (always using array of texts with keys)
export const aiTranslate = async (
  client: AxiosInstance,
  textData: string | TranslationItem[],
  sourceLang: string,
  targetLang: string
): Promise<TranslationItem[]> => {
  try {
    debugger;

    // Always use array format for consistency
    let translationItems: TranslationItem[];

    if (Array.isArray(textData)) {
      // Already in the right format
      translationItems = textData;
    } else {
      // Convert single string to a TranslationItem with a generated key
      translationItems = [
        {
          key: `auto-${Date.now()}`, // Generate a temporary key
          text: textData,
        },
      ];
    }

    // Always send array format
    const payload = {
      texts: translationItems,
      sourceLang,
      targetLang,
    };

    const response = await client.post("/backoffice/translations/ai", payload);

    // Always return translation items array
    return response.data.translations;
  } catch (error) {
    console.error("Error with AI translation:", error);
    throw error;
  }
};

// Export the interface for use in other files
export type { TranslationItem };

// Function to get a translation file from S3 using a signed URL
export const downloadTranslationFile = async (
  client: AxiosInstance,
  fileName: string
): Promise<TranslationObject> => {
  try {
    // Get signed URL from our API
    const { data } = await client.get(`/backoffice/translations/${fileName}`);

    // Use standard axios to download from S3
    const response = await axios.get(data);
    return response.data;
  } catch (error) {
    console.error(`Error downloading translation file ${fileName}:`, error);
    throw error;
  }
};

// Function to upload a translation file to S3 using a signed URL
export const uploadTranslationFile = async (
  client: AxiosInstance,
  fileName: string,
  data: TranslationObject
): Promise<void> => {
  try {
    // Get signed URL from our API
    const response = await client.put(`/backoffice/translations/${fileName}`);
    const uploadUrl = response.data;

    // Use standard axios to upload to S3
    await axios.put(uploadUrl, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.error(`Error uploading translation file ${fileName}:`, error);
    throw error;
  }
};

// Function to get available language codes
export const getTranslationFiles = async (
  client: AxiosInstance
): Promise<string[]> => {
  try {
    const response = await client.get("/backoffice/translations");

    // API directly returns the list of language codes
    return response.data.languages;
  } catch (error) {
    console.error("Error fetching available languages:", error);
    throw error;
  }
};
